import { PLATFORMS } from '@constants';

export const navigationLinks = {
  [PLATFORMS.FRANCE]: [
    {
      id: 'footer.navigation.help',
      href: 'footer.navigation.help.href',
      dataQa: 'contactCta',
    },
    {
      id: 'footer.navigation.account',
      href: 'footer.navigation.account.href',
      dataQa: 'accountProfileCta',
    },
    {
      id: 'footer.navigation.orders',
      href: 'footer.navigation.orders.href',
      dataQa: 'accountOrderCta',
    },
    {
      id: 'footer.navigation.about',
      href: 'footer.navigation.about.href',
      dataQa: 'aboutUsCta',
    },
    {
      id: 'footer.navigation.brands',
      href: 'footer.navigation.brands.href',
      dataQa: 'brandListCta',
    },
    {
      id: 'footer.navigation.recruiting-sellers',
      href: 'footer.navigation.recruiting-sellers.href',
      dataQa: 'recruitingSellerCta',
    },
    {
      id: 'footer.navigation.advertisements',
      href: 'footer.navigation.advertisements.href',
      dataQa: 'talkAboutUsCta',
      rel: 'noopener',
    },
    {
      id: 'footer.navigation.press.contact',
      href: 'footer.navigation.press.contact.href',
      dataQa: 'pressCta',
    },
    {
      id: 'footer.navigation.blog',
      href: 'footer.navigation.blog.href',
      dataQa: 'blogCta',
      rel: 'noopener',
    },
    {
      id: 'footer.navigation.recruitment',
      href: 'footer.navigation.recruitment.href',
      dataQa: 'recruitingCta',
      rel: 'noopener',
    },
    {
      id: 'footer.navigation.affiliation',
      href: 'footer.navigation.affiliation.href',
      dataQa: 'affiliateCta',
      rel: 'noopener',
    },
  ],
  [PLATFORMS.SPAIN]: [
    {
      id: 'footer.navigation.help',
      href: 'footer.navigation.help.href',
      dataQa: 'contactCta',
    },
    {
      id: 'footer.navigation.account',
      href: 'footer.navigation.account.href',
      dataQa: 'accountProfileCta',
    },
    {
      id: 'footer.navigation.orders',
      href: 'footer.navigation.orders.href',
      dataQa: 'accountOrderCta',
    },
    {
      id: 'footer.navigation.about',
      href: 'footer.navigation.about.href',
      dataQa: 'aboutUsCta',
    },
    {
      id: 'footer.navigation.brands',
      href: 'footer.navigation.brands.href',
      dataQa: 'brandListCta',
    },
    {
      id: 'footer.navigation.recruiting-sellers',
      href: 'footer.navigation.recruiting-sellers.href',
      dataQa: 'recruitingSellerCta',
    },
    {
      id: 'footer.navigation.press.contact',
      href: 'footer.navigation.press.contact.href',
      dataQa: 'pressCta',
    },
    {
      id: 'footer.navigation.blog',
      href: 'footer.navigation.blog.href',
      dataQa: 'blogCta',
      rel: 'noopener',
    },
    {
      id: 'footer.navigation.student-offer',
      href: 'footer.navigation.student-offer.href',
      dataQa: 'studentOffer',
    },
  ],
  [PLATFORMS.GREAT_BRITAIN]: [
    {
      id: 'footer.navigation.help',
      href: 'footer.navigation.help.href',
      dataQa: 'contactCta',
    },
    {
      id: 'footer.navigation.account',
      href: 'footer.navigation.account.href',
      dataQa: 'accountProfileCta',
    },
    {
      id: 'footer.navigation.orders',
      href: 'footer.navigation.orders.href',
      dataQa: 'accountOrderCta',
    },
    {
      id: 'footer.navigation.about',
      href: 'footer.navigation.about.href',
      dataQa: 'aboutUsCta',
    },
    {
      id: 'footer.navigation.brands',
      href: 'footer.navigation.brands.href',
      dataQa: 'brandListCta',
    },
    {
      id: 'footer.navigation.recruiting-sellers',
      href: 'footer.navigation.recruiting-sellers.href',
      dataQa: 'recruitingSellerCta',
    },
    {
      id: 'footer.navigation.press.contact',
      href: 'footer.navigation.press.contact.href',
      dataQa: 'pressCta',
    },
    {
      id: 'footer.navigation.blog',
      href: 'footer.navigation.blog.href',
      dataQa: 'blogCta',
      rel: 'noopener',
    },
    {
      id: 'footer.navigation.student-offer',
      href: 'footer.navigation.student-offer.href',
      dataQa: 'studentOffer',
    },
  ],
  [PLATFORMS.ITALY]: [
    {
      id: 'footer.navigation.help',
      href: 'footer.navigation.help.href',
      dataQa: 'contactCta',
    },
    {
      id: 'footer.navigation.account',
      href: 'footer.navigation.account.href',
      dataQa: 'accountProfileCta',
    },
    {
      id: 'footer.navigation.orders',
      href: 'footer.navigation.orders.href',
      dataQa: 'accountOrderCta',
    },
    {
      id: 'footer.navigation.about',
      href: 'footer.navigation.about.href',
      dataQa: 'aboutUsCta',
    },
    {
      id: 'footer.navigation.brands',
      href: 'footer.navigation.brands.href',
      dataQa: 'brandListCta',
    },
    {
      id: 'footer.navigation.recruiting-sellers',
      href: 'footer.navigation.recruiting-sellers.href',
      dataQa: 'recruitingSellerCta',
      rel: 'noopener',
    },
    {
      id: 'footer.navigation.blog',
      href: 'footer.navigation.blog.href',
      dataQa: 'blogCta',
      rel: 'noopener',
    },
    {
      id: 'footer.navigation.student-offer',
      href: 'footer.navigation.student-offer.href',
      dataQa: 'studentOffer',
    },
  ],
  [PLATFORMS.GERMANY]: [
    {
      id: 'footer.navigation.help',
      href: 'footer.navigation.help.href',
      dataQa: 'contactCta',
    },
    {
      id: 'footer.navigation.account',
      href: 'footer.navigation.account.href',
      dataQa: 'accountProfileCta',
    },
    {
      id: 'footer.navigation.orders',
      href: 'footer.navigation.orders.href',
      dataQa: 'accountOrderCta',
    },
    {
      id: 'footer.navigation.about',
      href: 'footer.navigation.about.href',
      dataQa: 'aboutUsCta',
    },
    {
      id: 'footer.navigation.brands',
      href: 'footer.navigation.brands.href',
      dataQa: 'brandListCta',
    },
    {
      id: 'footer.navigation.recruiting-sellers',
      href: 'footer.navigation.recruiting-sellers.href',
      dataQa: 'recruitingSellerCta',
    },
    {
      id: 'footer.navigation.blog',
      href: 'footer.navigation.blog.href',
      dataQa: 'blogCta',
      rel: 'noopener',
    },
    {
      id: 'footer.navigation.student-offer',
      href: 'footer.navigation.student-offer.href',
      dataQa: 'studentOffer',
    },
  ],
};
